import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=3faa8430&scoped=true&"
import script from "./MentionList.vue?vue&type=script&lang=js&"
export * from "./MentionList.vue?vue&type=script&lang=js&"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=3faa8430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa8430",
  null
  
)

export default component.exports